// Re-export singleton ApiClient instance and the class itself
import { V2mApiClient } from "./V2mApiClient";
const apiClient = new V2mApiClient();
export { apiClient, V2mApiClient };
export * from "./generated/models";
// Generated API classes + runtime surface for consumers that construct their
// own client instances (e.g. the admin panel, which needs a per-environment
// base URL via its environment switcher rather than the single shared one).
export { AdminApi, AnalyticsApi, AuthenticationApi, BillingApi, ConfigApi, DefaultApi, DiagApi, HealthApi, MetaApi, PaymentsApi, PluginConfigApi, QuotaApi, SessionApi, VigilApi, } from "./generated/apis";
export { Configuration, ResponseError } from "./generated/runtime";
export { openGenerateStream } from "./generate_stream";
export { openGenerateV2Stream } from "./generate_stream_v2";
